import Types from "./types";
import { LeadServiceJava } from "../../../service/lead-service-java-api";
import { SuperAppCmsService } from "../../../service/super-app-cms-service";

const setLocationName = (locationName) => ({
    type: Types.SET_CURRENT_LOCATION_NAME,
    locationName
});

const setPlaceID = (placeID) => ({
    type: Types.SET_CURRENT_LOCATION_ID,
    placeID
});

const setSelectionType = (selectionType) => ({
    type: Types.SET_SELECTION_TYPE,
    selectionType
});

const setPricepageCMS = (data) => ({
    type: Types.SET_PRICE_PAGE_CMS,
    data
});

const fetchLeadDetails = (token, params, secureToken) => () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.fetchLeadDetails(token, params, false, secureToken).then(response => {
            resolve(response.data.detail);
        }).catch(error => {
            reject(error);
        });
    });
};

const fetchAppointmentDetails = (token) => () => { // todo: remove this function
    return new Promise((resolve, reject) => {
        LeadServiceJava.getAppointmentDetailsByToken(token).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

const fetchAppointmentDetailsProtected = (token, secureToken) => () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getAppointmentDetailsByTokenProtected(token, secureToken).then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
        });
    });
};

const getCmsPageTemplateData = (payload) => dispatch => {
    return new Promise((resolve, reject) => {
        SuperAppCmsService.getCmsData(payload)
            .then(response => {
                const pageSections = response?.data?.data?.pageSections || [];
                dispatch(setPricepageCMS(pageSections));
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export {
    setLocationName,
    setPlaceID,
    setSelectionType,
    fetchLeadDetails,
    fetchAppointmentDetails,
    fetchAppointmentDetailsProtected,
    getCmsPageTemplateData,
    setPricepageCMS
};
